<template>
	<div class="incenters">
		<div style="">
			<Commondown types="2" backgroundColor="#FFF" fontSize="14px" v-if="qx.add" :datalist="downlist"
				@downs="downs" title="新增" :src="require('@/assets/icon/icon-add.png')">
			</Commondown>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" :useAutoOptional="false" :optional="!rowboo" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commondown types="2" backgroundColor="#FFF" v-if="qx.del" fontSize="14px" :datalist="downlistdel"
				@downs="downsdel" title="删除" :src="require('@/assets/icon/icon-del.png')">
			</Commondown>
			<CommonbtnUpLoad backgroundColor="#FFF" title="导入指标" fontSize="14px" @getFile="Export"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Import"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<a class="Dowload" style="" @click="dealDowload">下载指标导入模板</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="1000px" title="新增客户采购指标" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist ref="addtop" :key="'add'+index" :pt="pt" :jxs="jxs" :event="item.event"
						@remoteMethodtows="remoteMethodtows" @remoteMethodtow="remoteMethodtow"
						@remoteMethod="remoteMethod" @jxsType="jxsType" @hospitalChange="hospitalChange"
						:options="item.options" :btx="item.btx"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled">
					</Commondropdownlist>
				</template>
				<div style="height: 20px;">

				</div>
				<div class="dialogstyle" v-for="(item , index) of fromdataquarter" :key="index">
					<div
						style=" height: 16px; line-height: 16px; border-left: 4px solid #E71D43;margin-top: 10px;padding-left: 10px; color: #333333; font-weight: bold;">
						{{ item.title }}
					</div>
					<template v-for="(items , index) of item.data">
						<Commondropdownlist ref="addqt" :key="'dialogstyle'+index" :options="items.options"
							:btx="items.btx" :inputdata="items.inputdata" :title="items.title"
							:fontSize="items.fontSize" :color="items.color" :radiotite1="items.radiotitle1"
							:radiotitle2="items.radiotitle2" :lablewith="items.lablewith"
							:placeholder="items.placeholder" :types="items.types" :inputtype="items.inputtype"
							:width="items.width" :min="items.min" :max="items.max" :checkboxdata="items.checkboxdata"
							:disabled="items.disabled">
						</Commondropdownlist>
					</template>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="新增客户销售指标" :dialogVisible="dialogVisiblesSales" @cancel="cancelSales"
			@dialogOK="dialogOKSales">
			<div class="from">
				<template v-for="(item , index) of addSalesFormData">
					<Commondropdownlist ref="sales" :key="'Sales'+index" :pt="pt" :jxs="jxs" :event="item.event"
						@remoteMethodtows="remoteMethodtows" @remoteMethodtow="remoteMethodtow"
						@remoteMethod="remoteMethod" @SalesType="SalesType" @hospitalChange="hospitalChange"
						:options="item.options" :btx="item.btx"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled">
					</Commondropdownlist>
				</template>
				<div style="height: 20px;">

				</div>
				<div class="dialogstyle" v-for="(item , index) of fromdataSales" :key="index">
					<div
						style=" height: 16px; line-height: 16px; border-left: 4px solid #E71D43;margin-top: 10px;padding-left: 10px; color: #333333; font-weight: bold;">
						{{ item.title }}
					</div>
					<template v-for="(items , indexs) of item.data">
						<Commondropdownlist ref="dialogstyle" :key="'dialogstyle'+indexs" :options="items.options"
							:btx="items.btx" :inputdata="items.inputdata" :title="items.title"
							:fontSize="items.fontSize" :color="items.color" :radiotite1="items.radiotitle1"
							:radiotitle2="items.radiotitle2" :lablewith="items.lablewith"
							:placeholder="items.placeholder" :types="items.types" :inputtype="items.inputtype"
							:width="items.width" :min="items.min" :max="items.max" :checkboxdata="items.checkboxdata"
							:disabled="items.disabled">
						</Commondropdownlist>
					</template>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="1030px" title="修改经销商采购(销售)指标" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<template v-for="(item , index) of fromdataedit">
					<Commondropdownlist :key="'edit'+index" ref="edit" @updatedealer="updatedealer"
						@remoteMethodtows="remoteMethodtows" @remoteMethodtow="remoteMethodtow"
						@remoteMethod="remoteMethod" @hospitalChange="hospitalChange" :pt="pt" :jxs="jxs"
						:event="item.event" :options="item.options"
						:btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
						:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
						:checkboxdata="item.checkboxdata" :disabled="item.disabled">
					</Commondropdownlist>
				</template>
				<div style="height: 20px;">

				</div>
				<div class="dialogstyle" v-for="(item , index) of fromdataquarterdeit" :key="index">
					<div
						style=" height: 16px; line-height: 16px; border-left: 4px solid #E71D43;margin-top: 10px;padding-left: 10px; color: #333333; font-weight: bold;">
						{{ item.title }}
					</div>
					<template v-for="(item , index) of item.data">
						<Commondropdownlist ref="editdialogstyle" :key="'dialogstyle'+index" :pt="pt" :jxs="jxs"
							:event="item.event" @remoteMethodtows="remoteMethodtows" @remoteMethodtow="remoteMethodtow"
							@remoteMethod="remoteMethod" @SalesType="SalesType" :options="item.options" :btx="item.btx"
							:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
							:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
							:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
							:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
							:checkboxdata="item.checkboxdata" :disabled="item.disabled">
						</Commondropdownlist>
					</template>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" title="导入结果" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from" style="height: 400px;overflow: scroll;">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg"
					:headerData="headerData" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条指标吗？</span>
		</Dialog>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledelAll" @cancel="canceldelAll"
			@dialogOK="dialogOKdelAll" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除全部指标吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条档案吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import fromdataquarter from '../fromData/quarter'
	import fromdataquarterdeit from '../fromData/quarterdeit'
	import addSalesFormData from '../fromData/addSalesFormData'
	import fromdataSales from '../fromData/fromdataSales'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import {
		CustomerQuotaInfo,
		CustomerQuotaAdd,
		CustomerQuotaEdit,
		CustomerQuotaDelete,
		CustomerQuotaDeleteAll,
		CustomerQuotaImport,
		CustomerQuotaExport,
		BaOrganizationList,
		CustomerList,
		InventoryClassList,
		HospitalList,
			CustomerQuotaDownloadTemplet,
			HelperTechnicalOfficesList
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisiblesSales: false,
				dialogVisiblesU8: false,
				dialogVisiblesU8d: false,
				dialogVisibledelAll: false,
				dialogVisiblesdrjg: false,
				rightboo: false,
				dwonleft: false,
				rowboo: false,
				loading: true,
				id: null,
				ptype: '',
				yearState: null,
				pt: false,
				jxs: false,
				fromdataadd: [],
				fromdataedit: [],
				fromdataquarter: [],
				fromdataquarterdeit: [],
				addSalesFormData: [],
				fromdataSales: [],
				tableDatadrjg: [],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50,

					},
					{

						prop: 'QuotaTypeName',
						label: '指标类型',
						columnwidth: 100
					},
					{
						prop: 'CusName',
						label: '客户名称',
						columnwidth: 280
					},
					{
						prop: 'HospitalName',
						label: '医院名称',
						columnwidth: 130
					},
					{
						prop: 'TechnicalOfficesName',
						label: '科室',
						columnwidth: 130
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 80
					},
					{
						prop: 'SalesMan',
						label: '业务员',
						columnwidth: 130
					},
					{
						prop: 'Year',
						label: '年度',
						columnwidth: 70
					},
					{
						prop: 'JanQuota',
						label: '一月指标',
						columnwidth: 80
					},
					{
						prop: 'FebQuota',
						label: '二月指标',
						columnwidth: 80
					},
					{
						prop: 'MarQuota',
						label: '三月指标',
						columnwidth: 80
					},
					{
						prop: 'AprQuota',
						label: '四月指标',
						columnwidth: 80
					},
					{
						prop: 'MayQuota',
						label: '五月指标',
						columnwidth: 80
					},
					{
						prop: 'JunQuota',
						label: '六月指标',
						columnwidth: 80
					},
					{
						prop: 'JulQuota',
						label: '七月指标',
						columnwidth: 80
					},
					{
						prop: 'AugQuota',
						label: '八月指标',
						columnwidth: 80
					},
					{
						prop: 'SepQuota',
						label: '九月指标',
						columnwidth: 80
					},
					{
						prop: 'OctQuota',
						label: '十月指标',
						columnwidth: 80
					},
					{
						prop: 'NovQuota',
						label: '十一月指标',
						columnwidth: 80
					},
					{
						prop: 'DecQuota',
						label: '十二月指标',
						columnwidth: 80
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 130
					},
					{
						prop: 'CreateTime',
						label: '创建时间',
						columnwidth: 130
					},
					{
						prop: 'UpdaterName',
						label: '修改人',
						columnwidth: 130
					},
					{
						prop: 'UpdateTime',
						label: '修改时间',
						columnwidth: 130
					}
				],
				tableData1: [{
						kong: '',
						U8id: '1',
						U8number: '102100024',
					},
					{
						kong: '',
						U8id: '2',
						U8number: '102100024',
					},
					{
						kong: '',
						U8id: '3',
						U8number: '102100024',
					},
				],
				headerData1: [{
						prop: 'U8id',
						label: 'U8账套',
						columnwidth: 400,

					},
					{

						prop: 'U8number',
						label: 'U8编号',
						columnwidth: 522
					},
				],
				downlist: [{
						title: '新增采购指标',
						flag: true
					},
					{
						title: '新增销售指标',
						flag: true
					},
				],
				downlistdel: [{
						title: '删除选中项',
						flag: true
					},
					{
						title: '全部删除',
						flag: true
					},
				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
				from: {
					objType: null,
					cusCode: "",
					hospital: null,
					TechnicalOfficesID: null,
					invClass: "",
					year: "",
					janQuota: null,
					febQuota: null,
					marQuota: null,
					aprQuota: null,
					mayQuota: null,
					junQuota: null,
					julQuota: null,
					augQuota: null,
					sepQuota: null,
					octQuota: null,
					NovQuota: null,
					decQuota: null
				},
				quotaTypedeit: "",
				CusNameCode: null
			}
		},
		computed: {
			Year() {
				let date = new Date()
				let yearStr = `${date.getFullYear() - 1}-${date.getFullYear()}-${date.getFullYear() + 1}`
				let yearArr = [{
						key: date.getFullYear() - 1,
						value: date.getFullYear() - 1,
					},
					{
						key: date.getFullYear(),
						value: date.getFullYear(),
					},
					{
						key: date.getFullYear() + 1,
						value: date.getFullYear() + 1,
					},
				]
				return yearArr
			},
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.fromdataquarter = JSON.parse(JSON.stringify(fromdataquarter))
			this.fromdataquarterdeit = JSON.parse(JSON.stringify(fromdataquarterdeit))
			this.addSalesFormData = JSON.parse(JSON.stringify(addSalesFormData))
			this.fromdataSales = JSON.parse(JSON.stringify(fromdataSales))
			this.QX()

		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 35) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 43) {
								this.qus = items.Nodes
							}
						})
					}
					// console.log(this.qus, 'this.qus');
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						}
					})
				}
				//console.log("qux", this.qus)
			},

			// 新增
			async customerQuotaAdd(quotaType) {
				let {
					code,
					message
				} = await CustomerQuotaAdd({
					quotaType: quotaType + "",
					objType: this.from.objType,
					cusCode: this.from.cusCode,
					hospital: this.from.hospital,
					TechnicalOfficesID: this.from.TechnicalOfficesID,
					invClass: this.from.invClass,
					year: this.from.year,
					janQuota: this.from.janQuota,
					febQuota: this.from.febQuota,
					marQuota: this.from.marQuota,
					aprQuota: this.from.aprQuota,
					mayQuota: this.from.mayQuota,
					junQuota: this.from.junQuota,
					julQuota: this.from.julQuota,
					augQuota: this.from.augQuota,
					sepQuota: this.from.sepQuota,
					octQuota: this.from.octQuota,
					NovQuota: this.from.NovQuota,
					decQuota: this.from.decQuota

				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.rowboo = false
					if (quotaType == 0) {
						this.dialogVisiblesSales = false
						this.$refs.addtop.map((item, index) => {
							item.modelvalue = ""
						})
						this.$parent.customerQuotaList()
					}
					if (quotaType == 1) {
						this.dialogVisibles = false
						this.$refs.addqt.map((item, index) => {
							item.modelvalue = ""
						})
						this.$parent.customerQuotaList()
					}
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}

			},
			// 详情
			async customerQuotaInfo() {
				let {
					code,
					data
				} = await CustomerQuotaInfo({
					id: this.id
				})
				if (code == 0) {
					const hospitalId = data.Hospital || data.HPID || data.HospitalID || ''
					this.$refs.edit[0].modelvalue = String(data.ObjType)
					this.$refs.edit[1].modelvalue = data.InvClass
					this.$refs.edit[2].modelvalue = data.Year
					this.$refs.edit[3].options = hospitalId && data.HospitalName ? [{
						key: hospitalId,
						value: data.HospitalName
					}] : []
					this.$refs.edit[3].modelvalue = hospitalId || String(data.HospitalName || '')
					await this.loadTechnicalOfficesOptions(hospitalId, 'edit')
					if (this.fromdataedit[4] && data.TechnicalOfficesID && data.TechnicalOfficesName && !this.fromdataedit[4].options
						.some(item => item.key == data.TechnicalOfficesID)) {
						this.fromdataedit[4].options.push({
							key: data.TechnicalOfficesID,
							value: data.TechnicalOfficesName
						})
					}
					this.$refs.edit[4].modelvalue = data.TechnicalOfficesID || ''
					this.$refs.edit[5].modelvalue = String(data.CusName)
					this.$refs.edit[6].modelvalue = String(data.CusName)

					this.$refs.editdialogstyle[0].modelvalue = data.JanQuota
					this.$refs.editdialogstyle[1].modelvalue = data.FebQuota
					this.$refs.editdialogstyle[2].modelvalue = data.MarQuota
					this.$refs.editdialogstyle[3].modelvalue = data.AprQuota
					this.$refs.editdialogstyle[4].modelvalue = data.MayQuota
					this.$refs.editdialogstyle[5].modelvalue = data.JunQuota
					this.$refs.editdialogstyle[6].modelvalue = data.JulQuota
					this.$refs.editdialogstyle[7].modelvalue = data.AugQuota
					this.$refs.editdialogstyle[8].modelvalue = data.SepQuota
					this.$refs.editdialogstyle[9].modelvalue = data.OctQuota
					this.$refs.editdialogstyle[10].modelvalue = data.NovQuota
					this.$refs.editdialogstyle[11].modelvalue = data.DecQuota
					console.log(this.$refs.edit, this.Year, 'edit');
					this.$refs.edit[2].options = []

					this.Year.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value,
						}
						this.$nextTick(() => {
							this.$refs.edit[2].options.push(obj)
						})

					})
					if (this.$refs.edit[0].modelvalue == "1") {
						this.pt = true
						this.jxs = false
						this.CusNameCode = data.CusCode
						// this.HospitalList(data.CusName)
					} else if (this.$refs.edit[0].modelvalue == "2") {
						this.pt = false
						this.jxs = true
						this.CusNameCode = data.CusCode
						// this.CustomerList(data.CusName)
					}
				}
			},
			// 修改
			async customerQuotaEdit(datalist, datalisttow) {
				let {
					code,
					message
				} = await CustomerQuotaEdit({
					ID: this.id,
					quotaType: this.quotaTypedeit,
					objType: datalist[0].modelvalue,
					cusCode: this.CusNameCode,
					// cusCode: datalist[4].modelvalue == "null" ? "" : this.CusNameCode || datalist[4].modelvalue || datalist[5].modelvalue == "null" ? "" : this.CusNameCode || datalist[5].modelvalue,
					hospital: datalist[3].modelvalue == "null" ? "" : datalist[3].modelvalue,
					TechnicalOfficesID: datalist[4].modelvalue == "null" ? "" : datalist[4].modelvalue,
					invClass: datalist[1].modelvalue,
					year: datalist[2].modelvalue,
					janQuota: datalisttow[0].modelvalue,
					febQuota: datalisttow[1].modelvalue,
					marQuota: datalisttow[2].modelvalue,
					aprQuota: datalisttow[3].modelvalue,
					mayQuota: datalisttow[4].modelvalue,
					junQuota: datalisttow[5].modelvalue,
					julQuota: datalisttow[6].modelvalue,
					augQuota: datalisttow[7].modelvalue,
					sepQuota: datalisttow[8].modelvalue,
					octQuota: datalisttow[9].modelvalue,
					NovQuota: datalisttow[10].modelvalue,
					decQuota: datalisttow[11].modelvalue
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.rowboo == false
					this.$parent.customerQuotaList()
					this.dialogVisiblesedit = false
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 删除
			async customerQuotaDelete() {
				let {
					code,
					message
				} = await CustomerQuotaDelete({
					id: this.id
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.rowboo == false
					this.$parent.customerQuotaList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 全部删除
			async customerQuotaDeleteAll() {
				let {
					code,
					message
				} = await CustomerQuotaDeleteAll({
					id: this.id
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.rowboo == false
					this.$parent.customerQuotaList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},

			Import() {
				this.$emit('Import')
			},
			years() {
				if (this.yearState == 1) {
					if (this.$refs.addtop[2].options.length > 0) {
						this.$refs.addtop[2].options = []
					}
					let Arr = this.Year
					Arr.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value,
						}
						this.$refs.addtop[2].options.push(obj)
					})
				}


				if (this.yearState == 2) {

					if (this.$refs.sales[2].options.length > 0) {
						this.$refs.sales[2].options = []
					}
					let Arr = this.Year
					Arr.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value,
						}
						this.$refs.sales[2].options.push(obj)
					})

					// 默认展示二级经销商
					let e = this.$refs.dialogstyle[0]
					if (e.modelvalue == "1") {
						this.pt = true
						this.jxs = false
					} else if (e.modelvalue == "2") {
						this.pt = false
						this.jxs = true
					}
				}
			},
			// 
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {

					this.fromdataadd[1].options = []
					this.fromdataedit[1].options = []
					this.addSalesFormData[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.fromdataadd[1].options.push(obj)
						this.fromdataedit[1].options.push(obj)
						this.addSalesFormData[1].options.push(obj)
					})
				}
			},
			// 导入
			async Export(val) {
				var formdata = new FormData()
				formdata.append("file", val)
				if (val) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let {
						code,
						data,
						message
					} = await CustomerQuotaImport(
						formdata
					)
					if (code == 0) {
						loading.close();
						this.$message({
							type: 'success',
							message: message
						});
					} else {
						//console.log(data);
						this.tableDatadrjg = data
						loading.close();
						this.$message({
							type: 'error',
							message: message
						});
						this.dialogVisiblesdrjg = true
					}
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			async customerQuotaDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await CustomerQuotaDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			dealDowload() {
				this.customerQuotaDownloadTemplet()
			},
			async HospitalList(query) {
				let {
					code,
					data
				} = await HospitalList({
					hpName: query
				})
				if (code == 0) {
					this.CusNameCode = data.data[0].CusCode
				}
			},
			async remoteMethodtows(query) {
				this.loading = true
				let {
					code,
					data
				} = await HospitalList({
					hpName: query
				})
				if (code == 0) {
					this.fromdataedit[3].options = []
					this.addSalesFormData[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.fromdataedit[3].options.push(obj)
						this.addSalesFormData[3].options.push(obj)

					})
					this.loading = false
				}
			},
			async loadTechnicalOfficesOptions(hospitalId, target) {
				const formData = target === 'edit' ? this.fromdataedit : this.addSalesFormData
				const technicalOfficesIndex = 4
				if (formData[technicalOfficesIndex]) {
					formData[technicalOfficesIndex].options = []
				}
				if (!hospitalId) {
					return
				}
				let {
					code,
					data
				} = await HelperTechnicalOfficesList({
					Hospital: Number(hospitalId)
				})
				if (code == 0 && formData[technicalOfficesIndex]) {
					const list = Array.isArray(data) ? data : []
					formData[technicalOfficesIndex].options = list.map((item) => {
						return {
							key: item.Value,
							value: item.Text
						}
					})
				}
			},
			async hospitalChange(e) {
				if (this.$refs.sales && this.$refs.sales.includes(e)) {
					if (this.$refs.sales[4]) {
						this.$refs.sales[4].modelvalue = ''
					}
					await this.loadTechnicalOfficesOptions(e.modelvalue, 'sales')
				}
				if (this.$refs.edit && this.$refs.edit.includes(e)) {
					if (this.$refs.edit[4]) {
						this.$refs.edit[4].modelvalue = ''
					}
					await this.loadTechnicalOfficesOptions(e.modelvalue, 'edit')
				}
			},
			async CustomerList(query) {
				let {
					data,
					code
				} = await CustomerList({
					cusName: query,

				})
				if (code == 0) {
					this.CusNameCode = data.data[0].CusCode
				}
			},
			// 二级经销商下拉
			async remoteMethodtow(query) {
				this.loading = true
				let {
					data,
					code
				} = await CustomerList({
					CusName: query,

				})
				if (code == 0) {
					this.fromdataadd[4].options = []
					this.fromdataedit[6].options = []
					this.addSalesFormData[6].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName
						}
						this.fromdataadd[4].options.push(obj)
						this.fromdataedit[6].options.push(obj)
						this.addSalesFormData[6].options.push(obj)

					})
					this.loading = false
				}
			},
			// 一级经销商下拉
			async remoteMethod(query) {
				this.loading = true
				let {
					code,
					data
				} = await BaOrganizationList({
					companyName: query
				})
				if (code == 0) {
					this.fromdataadd[3].options = []
					this.fromdataedit[5].options = []
					this.addSalesFormData[5].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CompanyID,
							value: item.CompanyName
						}
						this.fromdataadd[3].options.push(obj)
						this.fromdataedit[5].options.push(obj)
						this.addSalesFormData[5].options.push(obj)

					})
					this.loading = false
				}
			},

			jxsType(e) {
				//console.log(e.modelvalue, 'eee')
				if (e.modelvalue == "1") {
					this.pt = true
					this.jxs = false
				} else if (e.modelvalue == "2") {
					this.pt = false
					this.jxs = true
				} else {
					this.pt = false
					this.jxs = false
				}
			},
			updatedealer(e) {
				//console.log(e.modelvalue, 'eee')
				if (e.modelvalue == "1") {
					this.pt = true
					this.jxs = false
				} else if (e.modelvalue == "2") {
					this.pt = false
					this.jxs = true
				} else {
					this.pt = false
					this.jxs = false
				}
			},
			SalesType(e) {
				if (e.modelvalue == "1") {
					this.pt = true
					this.jxs = false
				} else if (e.modelvalue == "2") {
					this.pt = false
					this.jxs = true
				} else {
					this.pt = false
					this.jxs = false
				}
			},
			onRowClick(val) {
				this.rowboo = true
				this.id = val.ID
				this.quotaTypedeit = val.QuotaType
				//console.log('val', val)
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			cancelSales() {
				this.dialogVisiblesSales = false
			},
			dialogOKSales() {
				this.from.objType = this.$refs.sales[0].modelvalue
				this.from.cusCode = this.$refs.sales[5].modelvalue || this.$refs.sales[6].modelvalue
				// this.from.cusCode = this.$refs.sales[5].modelvalue,
				this.from.hospital = Number(this.$refs.sales[3].modelvalue)
				this.from.TechnicalOfficesID = this.$refs.sales[4].modelvalue
				this.from.invClass = Number(this.$refs.sales[1].modelvalue)
				this.from.year = this.$refs.sales[2].modelvalue
				this.from.janQuota = this.$refs.dialogstyle[0].modelvalue
				this.from.febQuota = this.$refs.dialogstyle[1].modelvalue
				this.from.marQuota = this.$refs.dialogstyle[2].modelvalue
				this.from.aprQuota = this.$refs.dialogstyle[3].modelvalue
				this.from.mayQuota = this.$refs.dialogstyle[4].modelvalue
				this.from.junQuota = this.$refs.dialogstyle[5].modelvalue
				this.from.julQuota = this.$refs.dialogstyle[6].modelvalue
				this.from.augQuota = this.$refs.dialogstyle[7].modelvalue
				this.from.sepQuota = this.$refs.dialogstyle[8].modelvalue
				this.from.octQuota = this.$refs.dialogstyle[9].modelvalue
				this.from.NovQuota = this.$refs.dialogstyle[10].modelvalue
				this.from.decQuota = this.$refs.dialogstyle[11].modelvalue
				this.customerQuotaAdd(0)


			},
			adduser() {
				this.dialogVisibles = true
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.from.objType = String(this.$refs.addtop[0].modelvalue)
				this.from.cusCode = this.$refs.addtop[3].modelvalue || this.$refs.addtop[4].modelvalue
				this.from.hospital = null
				this.from.TechnicalOfficesID = null
				// this.from.cusCode = this.$refs.addtop[4].modelvalue,
				// this.from.hospital = this.$refs.addtop[0].modelvalue,
				this.from.invClass = this.$refs.addtop[1].modelvalue
				this.from.year = this.$refs.addtop[2].modelvalue
				this.from.janQuota = this.$refs.addqt[0].modelvalue
				this.from.febQuota = this.$refs.addqt[1].modelvalue
				this.from.marQuota = this.$refs.addqt[2].modelvalue
				this.from.aprQuota = this.$refs.addqt[3].modelvalue
				this.from.mayQuota = this.$refs.addqt[4].modelvalue
				this.from.junQuota = this.$refs.addqt[5].modelvalue
				this.from.julQuota = this.$refs.addqt[6].modelvalue
				this.from.augQuota = this.$refs.addqt[7].modelvalue
				this.from.sepQuota = this.$refs.addqt[8].modelvalue
				this.from.octQuota = this.$refs.addqt[9].modelvalue
				this.from.NovQuota = this.$refs.addqt[10].modelvalue
				this.from.decQuota = this.$refs.addqt[11].modelvalue
				this.customerQuotaAdd(1)

			},
			update() {
				if (this.rowboo == true) {
					this.pt = false
					this.jxs = false
					this.inventoryClassList()
					this.customerQuotaInfo()
					this.dialogVisiblesedit = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});

			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.customerQuotaEdit(this.$refs.edit, this.$refs.editdialogstyle)

			},
			downsdel(index) {
				if (index == 0) {
					if (this.rowboo == true) {
						this.dialogVisibledel = true
						return
					}
					this.$message({
						type: 'error',
						message: '请选择要删除的数据！'
					});

				}
				if (index == 1) {

					this.dialogVisibledelAll = true
				}
			},
			canceldelAll() {
				this.dialogVisibledelAll = false
			},
			dialogOKdelAll() {
				this.customerQuotaDeleteAll()
				this.dialogVisibledelAll = false
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.customerQuotaDelete()
				this.dialogVisibledel = false
			},
			deactivate() {
				this.dialogVisibledeactivate = true
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.dialogVisibledeactivate = false
			},
			downs(index) {
				if (index == 0) {
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					this.yearState = 1
					this.dialogVisibles = true
					this.inventoryClassList()
					try {
						setTimeout(() => {
							this.years()
							this.$refs.addtop[0].modelvalue = "2"
							this.pt = false
							this.jxs = true
							loading.close();
						}, 100);
					} catch (error) {}
				}
				if (index == 1) {
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					this.yearState = 2
					this.inventoryClassList()
					this.dialogVisiblesSales = true
					try {
						setTimeout(() => {
							this.years()
							this.$refs.sales[0].modelvalue = "2"
							this.pt = false
							this.jxs = true
							loading.close();
						}, 100);
					} catch (error) {}
				}
			},


		},
		watch: {

			dialogVisibles: {
				handler(newVal, oldVal) {
					//console.log(newVal, oldVal);
					if (newVal == true) {

						this.pt = false
						this.jxs = false
					}
				},
				deep: true
			},
			dialogVisiblesSales: {
				handler(newVal, oldVal) {
					//console.log(newVal, oldVal);
					if (newVal == true) {
						this.pt = false
						this.jxs = false
					}
				},
				deep: true
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
			// border: 1px solid red;
			height: 500px;
			overflow: scroll;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.dialogstyle {
		width: 952px;
		height: 100px;
		background: #ffffff;
		border: 1px solid #e6e6e6;
		margin-top: 10px;
	}
</style>
